<template>
  <el-dialog
    title="批量导入"
    :visible.sync="dialogVisible"
    custom-class="zyyj-dialog zyyj-d-upload"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <span style="font-size: 14px; color: #757575;">文件上传：1、请严格按照模版格式录入数据；2、导入失败时，请检查Excel中的数据录入</span>
    <el-upload
      v-loading="loading"
      ref="upload"
      class="zyyj-d-u-el-upload"
      drag
      :action="action"
      accept=".xlsx"
      :headers="myHeaders"
      :show-file-list="false"
      :on-success="handleUploadSuccess"
      :on-error="handleUploadError"
      :before-upload="beforeUpload"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将文件拖到此处，或
        <em>点击上传</em>
      </div>
      <div v-if="uploadResult.code === 422" slot="tip" class="el-upload__tip">导入文件格式与模版不匹配，请重新确认</div>
      <div v-else-if="uploadResult.code === 204" slot="tip" class="el-upload__tip">excel 中无有效数据</div>
      <div v-else-if="uploadResult.code === 500" slot="tip" class="el-upload__tip">请检查文件大小和格式，或联系管理员</div>
      <div v-else-if="uploadResult.code === 'template_error'" slot="tip" class="el-upload__tip">当前导入文件与模版与不一致，请重新检查后再试！</div>
      <div
        v-else-if="uploadResult.code === 400"
        slot="tip"
        class="el-upload__tip"
      >{{ uploadResult.data }}</div>
      <div v-else-if="uploadResult.total >= 0" slot="tip" class="el-upload__tip">
        <div slot="tip" class="el-upload__tip" style="font-size: 14px;">
          共导入 {{ uploadResult.total }} {{topic === '人' ? '人' : '所学校'}}，导入成功
          <span
            style="color: green;"
          >{{ uploadResult.successNumber }}</span>
          {{topic === '人' ? '人' : '所'}}
          <span
            v-if="uploadResult.failRecords.length > 0"
          >
            <span v-if="uploadResult.failNumber">，导入失败</span>
            <span v-if="uploadResult.failNumber" style="color: red;">{{ uploadResult.failNumber }}{{topic === '人' ? '人' : '所'}}，</span>
            <span
              style="color: var(--theme-color); cursor: pointer;"
              @click="downloadRecord"
            >
              点此下载失败记录
            </span>
          </span>
        </div>
      </div>
    </el-upload>
    <el-row class="zyyj-fail-record-row" v-if="hasFails">
      <el-col :span="24">
        <el-table
          :data="uploadResult.failRecords"
          size="medium"
          border
          :header-cell-style="{ background: '#f9f9f9' }"
        >
          <!-- slot for the standard el-table-column elements here -->
          <slot name="if-failure"></slot>
        </el-table>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" :disabled="loading" @click="handleDownloadTemplate">下载模板</el-button>
      <el-button type="primary" :disabled="loading" size="small" @click="closeDialog">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['topic', 'action', 'visible', 'template', 'errorUrl', 'type', 'headers'],

  data () {
    var token = localStorage.getItem('token')
    return {
      hasFails: false,
      uploadResult: {},
      myHeaders: { ...this.headers, Authorization: 'Bearer ' + token },
      loading: false
    }
  },

  computed: {
    dialogVisible: {
      get () { return this.visible === true },
      set () { this.$emit('update:visible', false) }
    }
  },

  methods: {
    handleDownloadTemplate () {
      this.$fetchFile(`${this.template}`, { name: `${this.type}导入模板`, isNeedFormwork: true })
    },

    downloadRecord () {
      this.$fetchFile(`${this.errorUrl}`, { name: `${this.type}导入失败记录`, failKey: this.uploadResult.failFileKey })
    },

    beforeUpload (file) {
      let isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.name.endsWith('.xlsx')
      if (!isExcel) {
        this.$message.error('上传文件的后缀必须是.xlsx格式!')
      } else {
        this.loading = true
      }
      const isLt1M = file.size / 1024 / 1024 < 1
      if (this.$regional.copyright === 'hengshui') {
        if (!isLt1M) {
          this.$message.error('上传文件大小不能超过 1 MB!')
          this.loading = false
          return false
        } else {
          this.loading = true
        }
      }
      return isExcel
    },

    handleUploadSuccess (resp) {
      this.uploadResult = 'data' in resp ? resp.data : resp
      console.log(resp)
      if ((this.type === '教师' || this.type === '学生') && this.uploadResult.failRecords) {
        this.uploadResult.failRecords = this.spliceData(this.uploadResult.failRecords)
      }
      this.hasFails = this.uploadResult.total > 0 && !_.isEmpty(this.uploadResult.failRecords)
      this.loading = false
      this.$emit('onSuccess', this.uploadResult)
    },

    spliceData (data) {
      if (data.length && data.length > 100) {
        let cloneData = _.cloneDeep(data)
        cloneData = cloneData.slice(0, 100)
        cloneData.push({
          objectName: '...',
          rowNum: '...',
          errorMessageList: ['更多导入失败数据请点击下载失败记录查看']
        })
        return cloneData
      } else {
        return data
      }
    },

    handleUploadError () {
      /* un-excpect error */
      this.uploadResult = { code: 500 }
      this.loading = false
    },

    closeDialog () {
      this.$emit('update:visible', false)
      if (this.uploadResult.total >= 0) {
        this.$emit('import-result', true)
      }
      this.$refs.upload.clearFiles()
      this.uploadResult = {}
      this.hasFails = false
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-upload__tip {
  margin-top: 20px;
  word-break: normal;
  line-height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ExcelImporterBox.vue